import { Variants } from "framer-motion";

// Ícone e ids de aprovação vivem no catálogo único de menu. Reexportados aqui
// para não quebrar os imports internos da sidebar (SidebarItem/SidebarSubMenu).
export {
  getMenuIcon,
  APROVACAO_MENU_IDS,
  APROVACAO_SUBMENU_IDS,
} from "@/components/menu/menu-catalog";

// --- DIMENSÕES E PERSISTÊNCIA ---
export const SIDEBAR_WIDTH_EXPANDED = "w-[280px]";
export const SIDEBAR_WIDTH_COLLAPSED = "w-[80px]";
export const STORAGE_KEY_COLLAPSED = "@workflow:sidebar-collapsed";
export const STORAGE_KEY_EXPANDED_MENUS = "@workflow:sidebar-expanded-menus";

// Busca só compensa quando há itens o bastante para justificar filtrar;
// abaixo disso o usuário enxerga tudo de relance no rail expandido.
export const SIDEBAR_SEARCH_MIN_ITEMS = 8;

// --- ANIMAÇÕES ---
export const navVariants: Variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.02, delayChildren: 0.03 },
  },
};

export const itemVariants: Variants = {
  hidden: { opacity: 0, x: -6 },
  show: { opacity: 1, x: 0, transition: { duration: 0.12, ease: "easeOut" } },
};

export const submenuVariants: Variants = {
  hidden: { height: 0, opacity: 0, transition: { duration: 0.15, ease: "easeInOut" } },
  visible: { height: "auto", opacity: 1, transition: { duration: 0.15, ease: "easeInOut" } },
};
